<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="用户搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入用户手机号/姓名搜索"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchTopBtn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="exportExcelBtn">数据导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="用户姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="用户手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="titleType"
            label="开票主体">
            <template slot-scope="scope">
              <span v-if="scope.row.titleType === 1">个人/非企业单位</span>
              <span v-else>企业</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="titleName"
            label="主体名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="invoiceMoney"
            label="开票金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="开票时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toOrderBtn(scope.row.id)" type="text" size="small">开票订单</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryInvoiceHistoryPageList, orderExportExcel } from '@/api/invoice'
export default {
  name: 'InvoiceRecord',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryInvoiceHistoryPageList({ webSearchStr: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 导出操作
    exportExcelBtn(){
      let that = this
      let searchName = that.searchForm.name
      that.fullscreenLoading = true;
      orderExportExcel({webSearchStr: searchName}).then((res) => {
        that.fullscreenLoading = false;
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '开票列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    /* 开票订单 */
    toOrderBtn (infoId) {
      this.$router.push({path: '/invoice_order', query: {dataId: infoId}})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/invoice/Record.vue